import { render } from "./VsCard.vue?vue&type=template&id=0dd25a66"
import script from "./VsCard.vue?vue&type=script&lang=js"
export * from "./VsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__